import styled from 'styled-components';
import { motion } from 'framer-motion';

export const ChatWidgetContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  
  @media (max-width: 768px) {
    bottom: 16px;
    right: 16px;
  }
  
  @media (max-width: 480px) {
    bottom: 12px;
    right: 12px;
  }
  
  @media (max-width: 360px) {
    bottom: 10px;
    right: 10px;
  }
`;

export const ChatButton = styled(motion.button)`
  position: relative;
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  border-radius: 50%;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  transition: box-shadow 0.3s ease;
  
  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  }
  
  @media (max-width: 480px) {
    width: 44px;
    height: 44px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  
  @media (max-width: 360px) {
    width: 40px;
    height: 40px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }

  &:hover {
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
    
    @media (max-width: 768px) {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    }
    
    @media (max-width: 480px) {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    }
    
    @media (max-width: 360px) {
      box-shadow: 0 3px 12px rgba(0, 0, 0, 0.2);
    }
  }
`;

export const NotificationDot = styled(motion.div)`
  position: absolute;
  top: -4px;
  right: -4px;
  width: 12px;
  height: 12px;
  background: #10b981;
  border-radius: 50%;
  
  @media (max-width: 768px) {
    width: 10px;
    height: 10px;
    top: -3px;
    right: -3px;
  }
  
  @media (max-width: 480px) {
    width: 8px;
    height: 8px;
    top: -2px;
    right: -2px;
  }
  
  @media (max-width: 360px) {
    width: 6px;
    height: 6px;
    top: -2px;
    right: -2px;
  }
`;

export const MessageCountBadge = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ef4444;
  color: white;
  font-size: 12px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  
  @media (max-width: 768px) {
    width: 18px;
    height: 18px;
    font-size: 11px;
    top: -3px;
    right: -3px;
  }
  
  @media (max-width: 480px) {
    width: 16px;
    height: 16px;
    font-size: 10px;
    top: -2px;
    right: -2px;
  }
  
  @media (max-width: 360px) {
    width: 14px;
    height: 14px;
    font-size: 9px;
    top: -2px;
    right: -2px;
  }
`;

export const Tooltip = styled(motion.div)`
  position: absolute;
  right: 64px;
  top: 50%;
  transform: translateY(-50%);
  background: #1f2937;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
  white-space: nowrap;
  
  @media (max-width: 768px) {
    right: 58px;
    font-size: 13px;
    padding: 6px 10px;
  }
  
  @media (max-width: 480px) {
    right: 52px;
    font-size: 12px;
    padding: 5px 8px;
  }
  
  @media (max-width: 360px) {
    right: 48px;
    font-size: 11px;
    padding: 4px 6px;
  }

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%) translateX(50%) rotate(45deg);
    width: 8px;
    height: 8px;
    background: #1f2937;
    
    @media (max-width: 768px) {
      width: 6px;
      height: 6px;
    }
    
    @media (max-width: 480px) {
      width: 5px;
      height: 5px;
    }
    
    @media (max-width: 360px) {
      width: 4px;
      height: 4px;
    }
  }
`;

export const ChatWindowContainer = styled(motion.div)`
  position: fixed;
  bottom: 80px;
  right: 24px;
  width: 100%;
  max-width: 448px;
  z-index: 9999;
  
  @media (max-width: 768px) {
    bottom: 70px;
    right: 16px;
    max-width: 380px;
    width: calc(100vw - 32px);
  }
  
  @media (max-width: 480px) {
    bottom: 60px;
    right: 12px;
    max-width: 320px;
    width: calc(100vw - 24px);
  }
  
  @media (max-width: 360px) {
    bottom: 50px;
    right: 8px;
    max-width: 280px;
    width: calc(100vw - 16px);
  }
  
  @media (max-width: 320px) {
    bottom: 45px;
    right: 6px;
    max-width: 260px;
    width: calc(100vw - 12px);
  }
`;
